export default __webpack_public_path__ + "static/media/pay_with_vipps_rect_210_NO.88761634.svg";